import { Switch, Route } from "react-router-dom";
import { useMemo } from "react";
import { Routes } from "./routes";

export const RouterManager = () => {
  const routes = useMemo(
    () =>
      Object.keys(Routes).map((path) => {
        const RouteComponent = Routes[path];
        return (
          <Route key={path} path={path}>
            <RouteComponent />
          </Route>
        );
      }),
    []
  );
  return <Switch>{routes}</Switch>;
};
